import styled from "styled-components";
import {
  SIDEBAR_WIDTH,
  SIDEBAR_COLLAPSED_WIDTH,
  MOBILE_BREAKPOINT,
} from "../PartnerSidebar/styles";

export const Shell = styled.div`
  min-height: 100vh;
  background: #f4efe8;
`;

export const Main = styled.main<{ $collapsed: boolean }>`
  margin-left: ${({ $collapsed }) => ($collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH)}px;
  min-height: 100vh;
  padding: 28px 32px 48px;
  box-sizing: border-box;
  transition: margin-left 0.2s ease;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-left: 0;
    padding: 16px 16px 40px;
  }
`;

export const TopBar = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Hamburger = styled.button`
  display: none;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid #e0d8ce;
    background: #ffffff;
    border-radius: 10px;
    cursor: pointer;
    color: #111;
    flex-shrink: 0;
  }
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h1`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 800;
  color: #111111;
  margin: 0;
  line-height: 1.15;

  @media (max-width: 700px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.p`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 14px;
  color: #8a7f74;
  margin: 0;
`;

export const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 700px) {
    flex-wrap: wrap;
  }
`;
